import querystring from 'querystring';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
import { completeLoginFlow } from './login-thunk';
import { selectAuthenticationError, selectAsyncStatus } from './login-selector';
import Routes from '../../constants/routes';
import { hasFailed } from '../../constants/async-status';
import { selectAppConfigs } from '../app-config/app-config-selector';

const LoginCallback = () => {
    const dispatch = useDispatch();
    const authenticationError = useSelector(selectAuthenticationError);
    const asyncStatus = useSelector(selectAsyncStatus);
    const appConfig = useSelector(selectAppConfigs);
    useEffect(() => {
        if (isLoginRedirect()) {
            dispatch(completeLoginFlow());
        }
    });
    const isLoginRedirect = () => {
        const queryParams = window.location.search
            ? querystring.decode(window.location.search.replace('?', ''))
            : querystring.decode(window.location.hash.replace('#', ''));

        console.log('queryParams', queryParams);

        const redirect =
            appConfig.USE_KEYCLOAK === 'true'
                ? Object.values(queryParams).every(
                      (param) => param !== null && param !== ''
                  )
                : Object.keys(queryParams).length === 6 && // Keeping this big block as a reminder that we use a different Auth0 implementation than our other apps
                  queryParams.access_token !== '' &&
                  queryParams.scope !== '' &&
                  queryParams.expires_in !== '' &&
                  queryParams.token_type !== '' &&
                  queryParams.state !== '' &&
                  queryParams.id_token !== '';

        console.log('redirect', redirect);

        return redirect;
    };
    return authenticationError && hasFailed(asyncStatus) ? (
        <Redirect to={Routes.ERROR_PAGE} />
    ) : (
        <Loader className="login-callback-loader" isBlocking isVisible />
    );
};

export default LoginCallback;
